<template>
  <div v-rect-loading="loading" class="edit-status-container">
    <div class="status-editor-header">
      <div class="status-editor-title">{{ titleLabel }}</div>
    </div>
    <div class="status-info-container">
      <WrappedFrom
        ref="form"
        class="status-info"
        label-width="220px"
        :model="statusInfo"
        :formLines="formLines"
      ></WrappedFrom>
      <div class="bottom-btn-group">
        <el-button class="cancel-btn" @click="handleCancel">{{ $t('common.btn.cancel') }}</el-button>
        <el-button class="save-btn" type="primary" @click="handleSave">{{ $t('common.btn.save') }}</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import WrappedFrom from '@/components/formEditor/wrappedForm.vue'

export default {
  components: {
    WrappedFrom
  },
  data () {
    return {
      i18nPrefix: 'admin.company.candidateStatusManagement',
      loading: false,
      statusInfo: {
        name_cn: null,
        name_en: null
      }
    }
  },
  computed: {
    statusKey () {
      return this.$route.params.statusKey
    },
    isEdit () {
      return this.$route.meta.isEdit
    },
    titleLabel () {
      if (this.isEdit) {
        return this.$t(`${this.i18nPrefix}.label.editCandidateStatus`)
      }
      return this.$t(`${this.i18nPrefix}.label.addCandidateStatus`)
    },
    formLines () {
      const lines = {
        name_cn: {
          label: this.$t(`${this.i18nPrefix}.label.cnName`),
          rules: [{ required: true, message: this.$t('common.message.requiredFormField'), trigger: 'blur' }]
        },
        name_en: {
          label: this.$t(`${this.i18nPrefix}.label.enName`),
          rules: [{ required: true, message: this.$t('common.message.requiredFormField'), trigger: 'blur' }]
        }
      }

      return lines
    }
  },
  created () {
    this.initPage()
  },
  methods: {
    ...mapActions('candidateStatus', ['getCandidateStatusInfoByStatusKey', 'createCandidateStatus', 'updateCandidateStatus']),
    initPage () {
      this.loadStatusInfo()
    },
    async loadStatusInfo () {
      if (!this.statusKey) {
        return
      }
      this.loading = true
      try {
        const resp = await this.getCandidateStatusInfoByStatusKey({ status_key: this.statusKey })
        if (resp) {
          this.statusInfo = resp
        }
      } finally {
        this.loading = false
      }
    },
    handleCancel () {
      this.$router.back()
    },
    async handleSave () {
      this.loading = true
      const saveFunc = this.isEdit ? this.updateCandidateStatus : this.createCandidateStatus
      const statusInfo = {
        name_cn: this.statusInfo.name_cn.trim(),
        name_en: this.statusInfo.name_en.trim(),
        status_key: this.statusInfo?.key,
        is_enabled: this.statusInfo?.is_enabled
      }
      try {
        const resp = await saveFunc(statusInfo)
        if (resp) {
          this.$message({
            type: 'success',
            message: this.$t(`${this.i18nPrefix}.message.saveStatusSuccess`)
          })
          this.handleCancel()
        }
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.edit-status-container {
  .status-editor-header {
    display: flex;
    border-bottom: 1px solid #e4e7ed;
    .status-editor-title {
      padding-top: 4px;
      padding-bottom: 18px;
      line-height: 25px;
      font-size: 18px;
      font-weight: 500;
      color: #303133;
    }
  }
  .status-info-container {
    width: 606px;
    margin: 30px auto 0;
    .status-info {}
    .bottom-btn-group {
      display: flex;
      justify-content: flex-end;

      .el-button {
        padding: 8px 28px;
        border-radius: 2px;
        line-height: 22px;
        font-size: 16px;
        font-weight: 500;
        color: #0096cc;

        &:last-child {
          margin-left: 24px;
          margin-right: 0;
          background: #0096cc;
          border-color: #0096cc;
          color: #ffffff;
        }
      }
    }
  }
}
</style>
